<style scoped>
.date-time-picker .field-input {
  height: 34px !important;
}
</style>

<template>
  <contact-form
    ref="personalInformation"
    :model="model"
    :wizard="wizard"
    @success="updateContactInformation"
    @move-to-next-tab="moveToNextTab"
  />
</template>

<script>
import helper from '@/libs/helper';
import { EMPLOYMENT_TAB } from '@/components/profile/sections/tabs/tabNumbers';
import ContactForm from '@/components/profile/sections/tabs/contact/ContactForm';

export default {
  components: {
    ContactForm,
  },
  data() {
    return {
      model: {},
      wizard: true,
      EMPLOYMENT_TAB,
    };
  },
  methods: {
    isValid() {
      return this.$refs.personalInformation.isValid();
    },
    clearValidationErrors() {
      this.$refs.personalInformation.clearValidationErrors();
    },
    moveToNextTab(moveTab) {
      if (moveTab) {
        this.$emit('move-to-next-tab', EMPLOYMENT_TAB);
      }
    },
    updateContactInformation() {
      this.$emit('tab-info-updated', 'Contact');
    },
    toggleSameAddress(value) {
      this.mailingAddressModel.sameAddress = value;
    },
  },
  mounted() {
    const profile = this.$store.getters.profile;
    if (profile && profile.contact) {
      this.model = helper.copy(profile.contact);
      this.model.phones.forEach((phone) => {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        phone.number = helper.phoneMask(phone.number);
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/contact/ContactContent.vue